'use client'

import {
  Col,
  CopyButton,
  getBankDetailsFromCardNumberOrEnName,
  Row,
  Typography,
} from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { useMemo } from 'react'
import { useIsDesktop } from '@repo/ui/hooks'
interface CardToCardCardItemProps {
  enName: string
  card?: string
  sheba?: string
  showBankName?: boolean
}

export const CardToCardCardItem = ({
  enName,
  card,
  showBankName = true,
}: CardToCardCardItemProps) => {
  const isDesktop = useIsDesktop()

  const { t } = useTranslate()
  const bankDetails = useMemo(() => {
    return getBankDetailsFromCardNumberOrEnName(card, enName)
  }, [enName, card])

  return (
    <Row className='gap-md justify-between border border-neutral-surface-dark rounded-xs p-xs md:p-2xs '>
      <Row className='gap-sm w-fit'>
        {bankDetails?.icon}
        <Col className='gap-2xs'>
          {showBankName && (
            <Typography
              size='sm'
              weight='bold'
              color='text-neutral-surface-100'
            >
              {t('walletDepositCardToCardPage_card_bank')} {bankDetails?.name}
            </Typography>
          )}
          {card && !isDesktop && (
            <Typography
              size='sm'
              weight='regular'
              color='text-neutral-surface-100'
              className='ltr'
            >
              {card.slice(0, 4)}{' '}
              <span className='mx-2xs text-neutral-surface-20  '>- </span>{' '}
              {card.slice(4, 8)}{' '}
              <span className='mx-2xs text-neutral-surface-20'>-</span>{' '}
              {card.slice(8, 12)}{' '}
              <span className='mx-2xs text-neutral-surface-20'>-</span>
              {card.slice(12, 16)}
            </Typography>
          )}
        </Col>
      </Row>
      <Row className='gap-md w-fit'>
        {card && isDesktop && (
          <Typography
            size='sm'
            weight='regular'
            color='text-neutral-surface-100'
            className='ltr'
          >
            {card.slice(0, 4)}{' '}
            <span className='mx-2xs text-neutral-surface-20  '>- </span>{' '}
            {card.slice(4, 8)}{' '}
            <span className='mx-2xs text-neutral-surface-20'>-</span>{' '}
            {card.slice(8, 12)}{' '}
            <span className='mx-2xs text-neutral-surface-20'>-</span>
            {card.slice(12, 16)}
          </Typography>
        )}
        <CopyButton
          text={card ?? ''}
          nonActiveTitle={t('common_copy')}
          activeMessageTitle={t('common_copied')}
        />
      </Row>
    </Row>
  )
}
